import Vue from 'vue'
import App from './App.vue'
// import './utils/rem';
import PublicVar from "./assets/js/publicVar";
import crypto from './assets/js/crypto'
import ElementUI from 'element-ui';
import router from './router'
import store from './vuex/store'
import httpPlugin from './assets/js/http'
import './assets/css/pulic.less';
import 'element-ui/lib/theme-chalk/index.css';
import PublicFn from "./assets/js/publicFn";
import matchFn from "./assets/js/matching";
import plugins from "./assets/js/plugins";

//引入字体图标
import './assets/font/iconfont.css';
//引入全局样式
import './assets/css/pulic.less';
import moment from "vue-moment"
import Video from 'video.js'
import 'video.js/dist/video-js.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
Vue.prototype.$video = Video;
Vue.use(moment);

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(plugins);
Vue.use(httpPlugin);
Vue.prototype.QCefClient=window.QCefClient;
Vue.prototype.QCefQuery=window.QCefQuery;
Vue.prototype.PublicFn = PublicFn;
Vue.prototype.matchFn = matchFn;
Vue.prototype.crypto = crypto;
Vue.prototype.PublicVar = PublicVar;

import audio from './components/audio/audio'
Vue.use(audio);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
